// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"55a2d546","81":"f8636cb0","88":"4d2edc42","653":"1e189178","840":"f0e59304"}[chunkId] + ".chunk.js";
};